import { render, staticRenderFns } from "./EnSavoirPlus.vue?vue&type=template&id=56d29170&scoped=true"
import script from "./EnSavoirPlus.vue?vue&type=script&lang=js"
export * from "./EnSavoirPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d29170",
  null
  
)

export default component.exports